module.exports = __webpack_public_path__ + "img/swich_close.24b76b0d.png";